import script from "./my-orders.vue?vue&type=script&lang=ts&setup=true"
export * from "./my-orders.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__